module.exports = __webpack_public_path__ + "img/banner-cashback.5fb07bb2.png";